import { set } from 'lodash/fp';
import createReducer from '../../../../../helpers/createReducer';
import {
  fetchReservationForEdit,
  updateReservation
} from '../../../sagas/routines';
import { clearReservationEdit } from '../../../actions/routes/edit';

const initialState = {
  data: null,
  fetching: false,
  fetched: false,
  saving: false,
  saved: false
};

const fetchReservationEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, fetching: true, fetched: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    fetching: false,
    fetched: true
  })
});

const updateReservationEditHandler = routine => ({
  [routine.TRIGGER]: state => ({ ...state, saving: true, saved: false }),
  [routine.SUCCESS]: (state, { payload: { response } }) =>
    set('data', response, state),
  [routine.FULFILL]: state => ({
    ...state,
    saving: false,
    saved: true
  })
});

const clearReservationEditHandler = action => ({
  [action.toString()]: () => initialState
});

export default createReducer(initialState, {
  ...fetchReservationEditHandler(fetchReservationForEdit),
  ...updateReservationEditHandler(updateReservation),
  ...clearReservationEditHandler(clearReservationEdit)
});
